/* unplugin-vue-components disabled */import { render } from "./enrollment.vue?vue&type=template&id=cebc804c&scoped=true"
import script from "./enrollment.vue?vue&type=script&lang=js"
export * from "./enrollment.vue?vue&type=script&lang=js"

import "./enrollment.vue?vue&type=style&index=0&id=cebc804c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebc804c"]])

export default __exports__